import { render, staticRenderFns } from "./SplashHeader.vue?vue&type=template&id=f7e9ec7a&scoped=true&"
import script from "./SplashHeader.vue?vue&type=script&lang=ts&"
export * from "./SplashHeader.vue?vue&type=script&lang=ts&"
import style0 from "./SplashHeader.vue?vue&type=style&index=0&id=f7e9ec7a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7e9ec7a",
  null
  
)

export default component.exports